



















import { defineComponent, computed, getCurrentInstance } from "vue";

import UiMenu from "@dpa-id-components/ui-menu";
import UiList from "@dpa-id-components/ui-list";
import UiListItem from "@dpa-id-components/ui-list-item";

import { useRoute, useRouter } from "vue-router/composables";
import getCurrentView from "@/composition/getCurrentView";
import useMatomoEvent from "@/composition/useMatomoEvent";

export default defineComponent({
  components: {
    UiMenu,
    UiList,
    UiListItem
  },
  setup() {
    const root = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();

    const query = computed(() => route.query);

    const params = computed(() => route.params);

    const getRouteForView = (view: string) => {
      return {
        params: params.value,
        query: {
          ...query.value,
          view
        }
      };
    };

    const items = computed(() => {
      return [
        {
          label: root.proxy.$t("Standard"),
          selected: route.query.view === "long",
          to: getRouteForView("long"),
          matomoEvent: {
            category: "View Selection new",
            name: "Click 'Standard' in View Selection",
            action: "Click 'Standard' in View Selection"
          }
        },
        {
          label: root.proxy.$t("Kompakt"),
          selected: route.query.view === "short",
          to: getRouteForView("short"),
          matomoEvent: {
            category: `${getCurrentView()} View`,
            name: "Click 'Kompakt' in View Selection",
            action: "Click 'Kompakt' in View Selection"
          }
        }
      ];
    });

    const selectedLabel = computed(() => {
      const found = items.value.find(item => item.selected);

      if (found && found.label) {
        return found.label;
      }

      return "";
    });

    return {
      items,
      router,
      selectedLabel,
      useMatomoEvent
    };
  }
});
